import { createStore, Store } from 'vuex'

const store :Store<any> = createStore({
  // state: {
  //   ADuser : [],
  // },

  // actions: {
  //   loadAdUsers({commit}){
  //     UserRepo.getUser()
  //     .then((data : AllAdUser) => {
  //       commit('SET_ADUSERS', data.items);
  //     }).catch( (e: string) => {
  //       console.log(e);
  //     })
  //   }
  // },
  // mutations: {
  //   SET_ADUSERS(state, adusers){
  //     state.ADuser = adusers;
  //   }
  // },
  // getters:{
  //   GET_ADUSERS(state){
  //     return state.ADuser;
  //   }
  // },
  modules: {

  }
})

export default store